import { forwardRef, useEffect, useRef, useState } from "react";

// 357: potvrzení vlevo nahoře v panelu (podle laboratoře, styl Asana): kolečko, při najetí se nakreslí
// fajfka, potvrzené tlačítko zezelená a poskočí. Konfety pouští ten, kdo potvrzení provede (lib/celebrate).
// 358: potvrzené s onClick jde klepnutím vrátit (schváleno omylem), bez onClick je jen stav.
export const ApproveButton = forwardRef(function ApproveButton({ label, done = false, onClick, disabled = false, title, testid }, ref) {
  const [pop, setPop] = useState(false);
  const was = useRef(done);
  useEffect(() => {
    const turnedOn = done && !was.current;
    was.current = done;
    if (!turnedOn) return undefined;
    setPop(true);
    const t = setTimeout(() => setPop(false), 400);
    return () => clearTimeout(t);
  }, [done]);
  return (
    <button ref={ref} type="button" onClick={onClick} disabled={disabled || (done && !onClick)} aria-pressed={done} title={title} data-testid={testid}
      className={`pp-approve ${pop ? "is-pop" : ""}`}>
      <span className="pp-approve__c" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 12.5l4 4L18 8" pathLength="16" /></svg></span>
      <span className="truncate">{label}</span>
    </button>
  );
});
